import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { ExternalLink } from 'lucide-react';
import type { ScopeOfWork_KeyResult } from '@/modules/__generated__/graphql/switchboard-generated';
import { KeyResultStatusChip } from '../key-result-status/key-result-status';
interface KeyResultModalProps {
  keyResult: ScopeOfWork_KeyResult;
}
function KeyResultModal(t0) {
  const $ = _c(15);
  const {
    keyResult
  } = t0;
  const hasLink = Boolean(keyResult.link && keyResult.link !== "");
  const t1 = hasLink ? "bg-foreground" : "bg-foreground/50";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("h-1.5 w-1.5 shrink-0 rounded-full", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <span className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = hasLink ? "text-foreground" : "text-foreground/50";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("flex items-center text-sm/5.5", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== keyResult.title || $[7] !== t5) {
    t6 = <div className="flex flex-col gap-1"><span className={t5}>{keyResult.title}</span></div>;
    $[6] = keyResult.title;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== hasLink) {
    t7 = hasLink ? <ExternalLink className="h-3.5 w-3.5" /> : <KeyResultStatusChip />;
    $[9] = hasLink;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t6 || $[13] !== t7) {
    t8 = <>{t3}{t6}{t7}</>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
export { KeyResultModal };